export enum RouteUrlParam {
  Pack = 'pack',
}
